export const OPEN_NOW_CATEGORY = "open_now";
export const OPEN_NOW_FILTER_OBJ = { key: OPEN_NOW_CATEGORY, name: OPEN_NOW_CATEGORY };
//# sourceMappingURL=openNowConst.js.map